var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 19.6875L27.1875 19.6875C27.7053 19.6875 28.125 19.2678 28.125 18.75V5.625C28.125 5.10723 27.7053 4.6875 27.1875 4.6875L2.8125 4.6875C2.29473 4.6875 1.875 5.10723 1.875 5.625V18.75C1.875 19.2678 2.29473 19.6875 2.8125 19.6875Z",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 22.5H26.25",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 25.3125H24.375",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.875C17.5888 16.875 19.6875 14.7763 19.6875 12.1875C19.6875 9.59867 17.5888 7.5 15 7.5C12.4112 7.5 10.3125 9.59867 10.3125 12.1875C10.3125 14.7763 12.4112 16.875 15 16.875Z",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 9.375C26.8818 9.375 25.6895 8.88114 24.8104 8.00206C23.9314 7.12299 23.4375 5.9307 23.4375 4.6875",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 9.375C2.49057 9.375 3.10011 9.25375 3.66883 9.01819C4.23754 8.78262 4.75429 8.43734 5.18956 8.00206C5.62484 7.56679 5.97012 7.05004 6.20569 6.48133C6.44125 5.91262 6.5625 5.30307 6.5625 4.6875",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 15C26.8818 15 25.6895 15.4939 24.8104 16.3729C23.9314 17.252 23.4375 18.4443 23.4375 19.6875",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 15C2.49057 15 3.10011 15.1212 3.66883 15.3568C4.23754 15.5924 4.75429 15.9377 5.18956 16.3729C5.62484 16.8082 5.97012 17.325 6.20569 17.8937C6.44125 18.4624 6.5625 19.0719 6.5625 19.6875",
    stroke: "var(--svg_current_color)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOutline);
export default __webpack_public_path__ + "static/media/cash-outline.f0c2529336d858fbf61e368882245a9f.svg";
export { ForwardRef as ReactComponent };